import JitsiMeetJS from '../../base/lib-jitsi-meet';
import { NOTIFY_CLICK_MODE } from '../../toolbox/constants';
export * from './functions.any';
/**
 * Removes all analytics related options from the given configuration, in case of a libre build.
 *
 * @param {*} _config - The configuration which needs to be cleaned up.
 * @returns {void}
 */
export function _cleanupConfig(_config) {
    return;
}
/**
 * Returns the replaceParticipant config.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean}
 */
export function getReplaceParticipant(state) {
    return state['features/base/config'].replaceParticipant;
}
/**
 * Returns the configuration value of web-hid feature.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean} True if web-hid feature should be enabled, otherwise false.
 */
export function getWebHIDFeatureConfig(state) {
    return state['features/base/config'].enableWebHIDFeature || false;
}
/**
 * Returns whether audio level measurement is enabled or not.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean}
 */
export function areAudioLevelsEnabled(state) {
    return !state['features/base/config'].disableAudioLevels && JitsiMeetJS.isCollectingLocalStats();
}
/**
 * Sets the defaults for deeplinking.
 *
 * @param {IDeeplinkingConfig} deeplinking - The deeplinking config.
 * @returns {void}
 */
export function _setDeeplinkingDefaults(deeplinking) {
    deeplinking.desktop = deeplinking.desktop || {};
    deeplinking.android = deeplinking.android || {};
    deeplinking.ios = deeplinking.ios || {};
    const { android, desktop, ios } = deeplinking;
    desktop.appName = desktop.appName || 'MalkaVRS Desktop';
    desktop.appScheme = desktop.appScheme || 'malkavrs';
    desktop.download = desktop.download || {};
    desktop.download.windows = desktop.download.windows
        || '/downloads/MalkaVRS-Desktop.exe';
    desktop.download.macos = desktop.download.macos
        || '/downloads/MalkaVRS-Desktop.dmg';
    desktop.download.linux = desktop.download.linux
        || '/downloads/MalkaVRS-Desktop.AppImage';
    ios.appName = ios.appName || 'MalkaVRS';
    ios.appScheme = ios.appScheme || 'malkavrs';
    ios.downloadLink = ios.downloadLink
        || '/downloads/MalkaVRS';
    if (ios.dynamicLink) {
        ios.dynamicLink.apn = ios.dynamicLink.apn || 'com.malkacomm.vrs';
        ios.dynamicLink.appCode = ios.dynamicLink.appCode || '';
        ios.dynamicLink.ibi = ios.dynamicLink.ibi || 'com.malkacomm.vrs';
        ios.dynamicLink.isi = ios.dynamicLink.isi || '';
    }
    android.appName = android.appName || 'MalkaVRS';
    android.appScheme = android.appScheme || 'malkavrs';
    android.downloadLink = android.downloadLink
        || 'https://play.google.com/store/apps/details?id=com.malkacomm.vrs';
    android.appPackage = android.appPackage || 'com.malkacomm.vrs';
    android.fDroidUrl = android.fDroidUrl || '';
    if (android.dynamicLink) {
        android.dynamicLink.apn = android.dynamicLink.apn || 'com.malkacomm.vrs';
        android.dynamicLink.appCode = android.dynamicLink.appCode || '';
        android.dynamicLink.ibi = android.dynamicLink.ibi || 'com.malkacomm.vrs';
        android.dynamicLink.isi = android.dynamicLink.isi || '';
    }
}
/**
 * Common logic to gather buttons that have to notify the api when clicked.
 *
 * @param {Array} buttonsWithNotifyClick - The array of systme buttons that need to notify the api.
 * @param {Array} customButtons - The custom buttons.
 * @returns {Array}
 */
const buildButtonsArray = (buttonsWithNotifyClick, customButtons) => {
    const customButtonsWithNotifyClick = customButtons?.map(({ id }) => {
        return {
            key: id,
            preventExecution: false
        };
    });
    const buttons = Array.isArray(buttonsWithNotifyClick)
        ? buttonsWithNotifyClick
        : [];
    if (customButtonsWithNotifyClick) {
        buttons.push(...customButtonsWithNotifyClick);
    }
    return buttons;
};
/**
 * Returns the list of toolbar buttons that have to notify the api when clicked.
 *
 * @param {Object} state - The redux state.
 * @returns {Array} - The list of buttons.
 */
export function getButtonsWithNotifyClick(state) {
    const { buttonsWithNotifyClick, customToolbarButtons } = state['features/base/config'];
    return buildButtonsArray(buttonsWithNotifyClick, customToolbarButtons);
}
/**
 * Returns the list of participant menu buttons that have that notify the api when clicked.
 *
 * @param {Object} state - The redux state.
 * @returns {Array} - The list of participant menu buttons.
 */
export function getParticipantMenuButtonsWithNotifyClick(state) {
    const { participantMenuButtonsWithNotifyClick, customParticipantMenuButtons } = state['features/base/config'];
    return buildButtonsArray(participantMenuButtonsWithNotifyClick, customParticipantMenuButtons);
}
/**
 * Returns the notify mode for the specified button.
 *
 * @param {string} buttonKey - The button key.
 * @param {Array} buttonsWithNotifyClick - The buttons with notify click.
 * @returns {string|undefined}
 */
export const getButtonNotifyMode = (buttonKey, buttonsWithNotifyClick) => {
    const notify = buttonsWithNotifyClick?.find((btn) => (typeof btn === 'string' && btn === buttonKey) || (typeof btn === 'object' && btn.key === buttonKey));
    if (notify) {
        return typeof notify === 'string' || notify.preventExecution
            ? NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY
            : NOTIFY_CLICK_MODE.ONLY_NOTIFY;
    }
};
